export default {

  handleFormValidation() {

    let oForm = $('#form-empresa');

    let aRules = {
      nombre: {
        required: true
      },
      rut: {
        required: true,
        rut: true
      },
    };

    let aMessages = {
      nombre: {
        required: 'El campo Nombre es obligatorio.'
      },
      rut: {
        required: 'El campo RUT es obligatorio.',
        rut: 'El campo RUT tiene un formato inválido.'
      },
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  initCombos() {
    $('#cmbTipo').select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });
  },

  initCheckBoxes() {
    $('#chkActivo').bootstrapSwitch({
      onText: 'SI',
      offText: 'NO'
    });
  },

  init() {
    this.handleFormValidation();
    this.initCombos();
    this.initCheckBoxes();
  },

  initIndex() {
    this.initCombos();
    FormHelper.handleSearch();
  },

  /**
   * Elimina un registro a traves de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} nombre Nombre del registro a eliminar
   */
  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar la Empresa <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  }
};
